import Vue from 'vue'
import Router from 'vue-router'

import p404 from '@/components/common/errors/p404'
// layouts
import CduLayout from '@/components/layout/CduLayout'
// pages
import Cdu from '@/components/pages/Cdu'
import SetDebugLevel from '@/components/common/SetDebugLevel'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    redirect: '/cdu'
  }, {
    path: '',
    name: 'cdu-layout',
    component: CduLayout,
    children: [
      {
        path: '/carousel',
        name: 'carousel',
        component: Cdu,
        props: true,
        redirect: '/carousel/screen1'
      }, {
        path: '/carousel/:screenid',
        name: 'carousel-screen',
        component: Cdu,
        props: true
      }, {
        path: '/cdu',
        name: 'cdu',
        component: Cdu,
        props: true,
        redirect: '/cdu/screen1'
      }, {
        path: '/cdu/:screenid',
        name: 'cdu-screen',
        component: Cdu,
        props: true,
        redirect: to => {
          if (to.params.screenid) {
            return '/cdu/:screenid/default/standard'
          } else {
            return '/cdu/screen1/default/standard'
          }
        }
      }, {
        path: '/cdu/:screenid/:client',
        name: 'cdu-client',
        component: Cdu,
        props: true,
        redirect: to => {
          if (to.params.screenid && to.params.client) {
            return '/cdu/:screenid/:client/standard'
          } else {
            return '/cdu/screen1/default/standard'
          }
        }
      },
      {
        path: '/cdu/:screenid/:client/:displaytemplate',
        name: 'cdu-client-displaytemplate',
        component: Cdu,
        props: true
      },
      {
        path: '/cdu/:screenid/:client/:displaytemplate/:big3columnsorder', // 1- MONEY, 2- TOTAL, 3- SPREAD (321 is default if no param specified
        name: 'cdu-client-displaytemplate-big3columnsorder',
        component: Cdu,
        props: true
      }
    ]
  }, {
    path: '/setdebug/:level',
    name: 'setDebug',
    component: SetDebugLevel,
    props: true
  }, {
    path: '/404',
    name: 'page-not-found',
    component: p404
  }, {
    path: '*',
    redirect: '/404'
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js